import React, { useCallback, useState } from "react";

import { Box, Grid } from "atoms";
import { ResetPasswordForm } from "molecules";
import { useAuth } from "contexts/Auth";
import { useLocation, useNavigate } from "react-router-dom";

const ResetPassword = ({ setLogin }) => {
  const {
    actions: { resetPassword },
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = useCallback(
    async ({ confirmPassword: password }) => {
      setLoading(true);
      resetPassword(location.state?.userEmail, password)
        .then((success) => {
          success &&
            navigate({
              pathname: "/reset-success",
            });
        })
        .catch((e) => {
          setError(e?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [resetPassword, navigate, location.state?.userEmail]
  );
  return (
    <Box h="100vh">
      <Grid aI="center" h="100vh" px="12rem">
        <ResetPasswordForm
          onSubmit={onSubmit}
          loading={loading}
          error={error}
          resetError={() => setError("")}
        />
      </Grid>
    </Box>
  );
};

export default ResetPassword;
